import { useState } from "react";
import { useStore } from "../../stores";
import { storeErrorLogs } from "../../services/chathub";
import { toast } from "bulma-toast";
import i18n from "../../services/localization";
import locale from "../../constants/locale";
import { MdOutlineHome, MdOutlineReportProblem } from "react-icons/md";
import { observer } from "mobx-react-lite";
import { Bot } from "../../models";

const ErrorRenderer = ({
  error,
}: {
  error: {
    message: string;
    stack: string;
  };
}) => {
  const { selectedBot } = useStore("bots");
  const { user } = useStore("auth");
  const [reportingError, setReportingError] = useState(false);

  const storeError = async (selectedBot: Bot | undefined) => {
    if (!selectedBot) {
      return; 
    }
    setReportingError(true);

    try {
      await storeErrorLogs(
        selectedBot.id,
        selectedBot.key,
        selectedBot.password,
        error.message,
        error.stack,
        user?.email
      );
      toast({
        message: "Error reported successfully",
        type: "is-success",
        dismissible: true,
        position: "top-right",
      });
    } catch (error) {
      toast({
        message: "Error while reporting error",
        position: "top-right",
        dismissible: true,
        type: "is-danger",
        pauseOnHover: true,
      });
    } finally {
      setReportingError(false);
    }
  };

  return (
    <div
      className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
      style={{
        minHeight: "100vh",
        padding: "2rem",
        width: "100%",
        background: "#f8f9fd",
      }}
    >
      <div
        className="card"
        style={{
          maxWidth: "600px",
          width: "100%",
          borderRadius: "0.5rem",
          overflow: "hidden",
          boxShadow: "0 2px 15px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          className="has-background-danger p-4 has-text-centered is-flex is-justify-content-center"
          style={{ backgroundColor: "#f55755 !important" }}
        >
          <img src="/assets/edna-sidebar-logo.png" alt="logo" width={50} />
        </div>

        <div className="card-content">
          <div className="content">
            <h5 className="has-text-weight-medium mb-4">
              Error: {error.message}
            </h5>

            <div className="notification is-light is-danger mb-4">
              <p className="has-text-weight-medium mb-2">
                {i18n.t(locale.details) as string}:
              </p>
              <div
                className="is-family-monospace"
                style={{
                  fontSize: "0.85rem",
                  maxHeight: "200px",
                  overflow: "auto",
                  whiteSpace: "pre-wrap",
                  backgroundColor: "#f8f8f8",
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                {error.stack}
              </div>
            </div>
          </div>
        </div>

        <div
          className="card-footer"
          style={{ borderTop: "1px solid rgba(222, 225, 230, 0.4)" }}
        >
          <div className="card-footer-item">
            <div className="buttons">
              <button
                className="button is-danger mr-2"
                disabled={reportingError}
                onClick={() => storeError(selectedBot)}
              >
                <span className="icon mr-2">
                  <MdOutlineReportProblem size={18} />
                </span>
                {reportingError ? "Reporting..." : "Report Issue"}
              </button>
              <button
                className="button"
                onClick={() => (window.location.href = "/")}
              >
                <span className="icon mr-2">
                  <MdOutlineHome size={18} />
                </span>
                Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(ErrorRenderer);
